import React from 'react';
import PropTypes from 'prop-types';

import { Wrapper } from './styles';
import { CloseIcon } from '@spa/shared/svg/close';

const CloseCard = ({ onClick }) => {
  return (
    <Wrapper className="popup-close" onClick={onClick}>
      <CloseIcon />
    </Wrapper>
  );
};

CloseCard.propTypes = {
  onClick: PropTypes.func
};

export default CloseCard;
